import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import "./style.scss";

const drawerRoot = document.createElement("div");
drawerRoot.setAttribute("id", "drawer-root");
drawerRoot.setAttribute("class", "drawer");

class Drawer extends React.Component {
  componentWillMount() {
    document.body.appendChild(drawerRoot);
  }

  componentWillUnmount() {
    const node = document.getElementById("drawer-root");
    document.body.removeChild(node);
  }

  renderOverlay() {
    if (this.props.showOverlay) {
      return <div className="drawer-overlay"></div>;
    } else {
      return null;
    }
  }

  render() {
    //if (this.props.visible) {
    return (
      <>
        {this.renderOverlay()}
        <div
          className={
            "drawer-content" + (this.props.expanded ? " section-expanded" : "")
          }
        >
          {this.props.children}
        </div>
      </>
    );
    //} else {
    //return null;
    //}
  }
}

Drawer.propTypes = {
  visible: PropTypes.bool,
  showOverlay: PropTypes.bool,
};
Drawer.defaultProps = {
  visible: false,
  showOverlay: true,
};

export const DrawerComponent = (props) =>
  ReactDOM.createPortal(
    <Drawer {...props}>{props.children}</Drawer>,
    drawerRoot
  );
DrawerComponent.prototype = {
  visible: PropTypes.bool,
  showOverlay: PropTypes.bool,
};
